var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPage',{attrs:{"code":"401","title":"errors.401_title","message":"errors.401_message"}})
}
var staticRenderFns = []

export { render, staticRenderFns }